module.exports = __webpack_public_path__ + "static/media/order_zone_active.337b9cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_zone_active.png
// module id = 1667
// module chunks = 0